export const COUPLE_SUB_COL = {
  RIGHT_THUMB: 'rightThumbnail',
  LEFT_THUMB: 'leftThumbnail',
  RIGHT_ITEM: 'rightItem',
  LEFT_ITEM: 'leftItem',
  ITEM: 'item', //legacy
  SECTION: 'section', //legacy
  MAIN: 'main', //legacy
  LAST: 'last', //legacy
  PHOTOCARDCOUPLE: 'photocardCouple',
} as const;

export type COUPLE_SUB_COL_KEY = keyof typeof COUPLE_SUB_COL;
export type COUPLE_SUB_COL_VALUE = typeof COUPLE_SUB_COL[COUPLE_SUB_COL_KEY];
